import React from 'react';
import styled from 'styled-components';

const TooltipIcon = styled.div`
  display: inline-block;
  margin-left: 12px;
  height: 16px;
  cursor: pointer;
`;

const TooltipContent = styled.div`
  position: absolute;
  right: calc(100% + 10px);
  width: 200px;
  background: #a5b9d3;
  padding: 22px 11px 22px 0px;
  visibility: hidden;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 5px;
  z-index: 1;
  color: #123058;
  display: flex;
  font-size: 14px;
  line-height: 18px;
  align-items: center;

  &:after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    clip-path: polygon(100% 0%, 100% 100%, 0% 0%);
    -webkit-clip-path: polygon(100% 0%, 100% 100%, 0% 0%);
    background-color: #a5b9d3;
    border-radius: 0 5px 0 0;
    position: absolute;
    left: calc(100% - 10px);
    transform: rotate(45deg);
    z-index: 0;
  }

  svg {
    margin-right: 7px;
    flex: 1 0 auto;
  }
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inherit;

  & ${TooltipIcon}:hover + ${TooltipContent} {
    visibility: visible;
  }
`;

const Tooltip = () => (
  <TooltipWrapper>
    <TooltipIcon tabIndex="-1">
      <svg width="16" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C3.58168 16 0 12.4183 0 8C0 3.58168 3.58168 0 8 0C12.4183 0 16 3.58168 16 8C16 12.4183 12.4183 16 8 16ZM8 15.0303C11.8828 15.0303 15.0303 11.8828 15.0303 8C15.0303 4.11723 11.8828 0.969697 8 0.969697C4.11723 0.969697 0.969697 4.11723 0.969697 8C0.969697 11.8828 4.11723 15.0303 8 15.0303ZM8.03634 5.33244C7.74863 5.33244 7.51513 5.09893 7.51513 4.81122C7.51513 4.52325 7.74863 4.29001 8.03634 4.29001C8.32431 4.29001 8.55755 4.52325 8.55755 4.81122C8.55755 5.09893 8.32431 5.33244 8.03634 5.33244ZM7.51518 6.86742C7.51518 6.59964 7.73225 6.38257 8.00002 6.38257C8.2678 6.38257 8.48487 6.59964 8.48487 6.86742V11.4677C8.48487 11.7354 8.2678 11.9525 8.00002 11.9525C7.73225 11.9525 7.51518 11.7354 7.51518 11.4677V6.86742Z"
          fill="#0058E6"
        />
      </svg>
    </TooltipIcon>
    <TooltipContent>
      <svg width="51" height="48" viewBox="0 0 51 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28 30.1333V35.8403H27.0586V31.2505L25.6641 31.7231V30.9458L27.8867 30.1333H28ZM33.7891 35.0903V35.8403H29.9766V35.1958L31.8281 33.1763C32.0312 32.9471 32.1914 32.7492 32.3086 32.5825C32.4258 32.4159 32.5078 32.2661 32.5547 32.1333C32.6042 31.9979 32.6289 31.8664 32.6289 31.7388C32.6289 31.5591 32.5951 31.4015 32.5273 31.2661C32.4622 31.1281 32.3659 31.02 32.2383 30.9419C32.1107 30.8612 31.9557 30.8208 31.7734 30.8208C31.5625 30.8208 31.3854 30.8664 31.2422 30.9575C31.099 31.0487 30.9909 31.175 30.918 31.3364C30.8451 31.4953 30.8086 31.6776 30.8086 31.8833H29.8672C29.8672 31.5526 29.9427 31.2505 30.0938 30.9771C30.2448 30.701 30.4635 30.4823 30.75 30.3208C31.0365 30.1567 31.3815 30.0747 31.7852 30.0747C32.1654 30.0747 32.4883 30.1385 32.7539 30.2661C33.0195 30.3937 33.2214 30.5747 33.3594 30.8091C33.5 31.0435 33.5703 31.3208 33.5703 31.6411C33.5703 31.8182 33.5417 31.994 33.4844 32.1685C33.4271 32.3429 33.3451 32.5174 33.2383 32.6919C33.1341 32.8638 33.0104 33.0369 32.8672 33.2114C32.724 33.3833 32.5664 33.5578 32.3945 33.7349L31.1641 35.0903H33.7891ZM35.6289 32.5708H36.1914C36.4102 32.5708 36.5911 32.533 36.7344 32.4575C36.8802 32.382 36.9883 32.2778 37.0586 32.145C37.1289 32.0122 37.1641 31.8599 37.1641 31.688C37.1641 31.5083 37.1315 31.3547 37.0664 31.2271C37.0039 31.0968 36.9076 30.9966 36.7773 30.9263C36.6497 30.856 36.487 30.8208 36.2891 30.8208C36.1224 30.8208 35.9714 30.8547 35.8359 30.9224C35.7031 30.9875 35.5977 31.0812 35.5195 31.2036C35.4414 31.3234 35.4023 31.4666 35.4023 31.6333H34.457C34.457 31.3312 34.5365 31.063 34.6953 30.8286C34.8542 30.5942 35.0703 30.4106 35.3438 30.2778C35.6198 30.1424 35.9297 30.0747 36.2734 30.0747C36.6406 30.0747 36.9609 30.1359 37.2344 30.2583C37.5104 30.3781 37.7253 30.5578 37.8789 30.7974C38.0326 31.0369 38.1094 31.3338 38.1094 31.688C38.1094 31.8494 38.0716 32.0135 37.9961 32.1802C37.9206 32.3468 37.8086 32.4992 37.6602 32.6372C37.5117 32.7726 37.3268 32.8833 37.1055 32.9692C36.8841 33.0526 36.6276 33.0942 36.3359 33.0942H35.6289V32.5708ZM35.6289 33.3052V32.7896H36.3359C36.6693 32.7896 36.9531 32.8286 37.1875 32.9067C37.4245 32.9849 37.6172 33.0929 37.7656 33.231C37.9141 33.3664 38.0221 33.5213 38.0898 33.6958C38.1602 33.8703 38.1953 34.0552 38.1953 34.2505C38.1953 34.5161 38.1471 34.7531 38.0508 34.9614C37.957 35.1672 37.8229 35.3416 37.6484 35.4849C37.474 35.6281 37.2695 35.7362 37.0352 35.8091C36.8034 35.882 36.5508 35.9185 36.2773 35.9185C36.0326 35.9185 35.7982 35.8846 35.5742 35.8169C35.3503 35.7492 35.1497 35.6489 34.9727 35.5161C34.7956 35.3807 34.6549 35.2127 34.5508 35.0122C34.4492 34.8091 34.3984 34.5747 34.3984 34.3091H35.3398C35.3398 34.4784 35.3789 34.6281 35.457 34.7583C35.5378 34.8859 35.6497 34.9862 35.793 35.0591C35.9388 35.132 36.1055 35.1685 36.293 35.1685C36.4909 35.1685 36.6615 35.1333 36.8047 35.063C36.9479 34.9927 37.0573 34.8885 37.1328 34.7505C37.2109 34.6125 37.25 34.4458 37.25 34.2505C37.25 34.0291 37.207 33.8494 37.1211 33.7114C37.0352 33.5734 36.9128 33.4718 36.7539 33.4067C36.5951 33.339 36.4076 33.3052 36.1914 33.3052H35.6289Z"
          fill="#123058"
        />
        <circle cx="31.5604" cy="33.1605" r="9.13748" stroke="#123058" strokeWidth="0.382979" />
        <rect y="6.12842" width="50" height="12.8205" fill="#123058" />
        <path
          d="M0 1H46.9089C48.601 1 49.9727 2.37172 49.9727 4.06383V44.09C49.9727 45.7821 48.601 47.1538 46.9089 47.1538H0"
          stroke="#123058"
          strokeWidth="0.382979"
        />
      </svg>

      <span>The last 3 digits on the back of your card</span>
    </TooltipContent>
  </TooltipWrapper>
);

export default Tooltip;
